import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";

export const dashboardService = {
    async getStatisticsAsync()
    {
         const response=await apiClient.get(endPoints.dashboard.getStatistics);
         return response.data
    },
}